import { Color, DefaultValue } from '@billy/design-system'
import styled from '@emotion/styled'

export const BillAttachmentPreviewWrapper = styled.div`
  height: 100%;
  border: 1px solid ${Color.Grey150};
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${Color.Grey100};
  overflow: hidden;
  cursor: grab;
`

export const BillAttachmentWrapper = styled.div`
  width: 100%;
  position: relative;
  /* another aspect ratio required due to inner spacing */
  aspect-ratio: 1 / 1.38;
`
